import api from './../service/apiService'
import { apiUrl } from './../constants/apiUrl'
import { logKafka,logOtherInfo,detailsInfo,catchJSException, logToKibanna } from './../service/logService'
import { redirectTo } from './redirection'
import { errorAction } from './error';
import { Deposit, CheckOut, FinalBill,Pages,PAGEACTIVITY } from './../constants/actionType'
import { getPieEncryptionVepsPayment } from './../util/commonUtil'
import { updateSCcustomEvent, tempSCData } from './../service/dtmTag';
import { InHomeUtils } from './../util/inhomeUtils';
import { tempVzdlSCData, updateVzdlSCCustomEvent } from '../service/vzdl';

export const validateDeposit = (action, dispatch) => {
    dispatch({ type: Deposit.validateDeposit, value: action });
}

const doFinalBillPayment = (visitId, dispatch, amount, inputDetail,  lqState, noOfAttempts,isReqdDepositafterFinalBill=false) => {
    let paymentCheck = apiUrl().vepsUrl;
    let request = getPaymentRequest(amount, inputDetail,  lqState, false,visitId, dispatch);
    if(!request) return;
    dispatch({ 
        type: 'LOADER_ACTIVE', 
        value: { isLoaderActive: true, isLoaderText: "", isLoaderImg: "loader" } 
    });
    if (noOfAttempts < 3) {
        api(paymentCheck, 'POST', request).then(response => {
            //response= resp.finalBillResponse;
            // response={
            //     "meta": {
            //       "code": 200.01,
            //       "description": " VEPS Payment Successful.",
            //       "timestamp": "Wed Mar 25 22:41:45 UTC 2020"
            //     },
            //     "data": {
            //       "code": "9950",
            //       "status": "Success",
            //       "message": "Success in VEPS.",
            //       "displayMessage": null,
            //       "action": "regularpayment",
            //       "pmtType": "VI"
            //     }
            //   };
            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.status)) {
                dispatch({ type: FinalBill.onUpdateFinalBill, value: response.data });

                if (response.data.status === 'Success') {
                    dispatch({ type: FinalBill.finalBillStatus, value: 'success' })

                    if(isReqdDepositafterFinalBill){
                        dispatch({ type: CheckOut.updateDepositInfo, value: true })
                    }
                    

                    tempSCData.detailPageName = "accord| info and credit- crd chk pass";
                    tempSCData.creditCheck = "Pass";
                    updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    tempVzdlSCData.detail = "info and credit- crd chk pass";
                    tempVzdlSCData.creditCheck = "Pass";
                    updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");
                }
                else if (response.data.status === 'Failed'|| response.data.status === 'Failure') {
                    dispatch({ type: FinalBill.finalBillStatus, value: 'fail' })
                    dispatch({ type: CheckOut.updateFinalBillAttempts, value: noOfAttempts + 1 })
                    dispatch({ type: CheckOut.updateCreditCheckAccordionStatus, value: 'required' })
                    dispatch({ type: CheckOut.updateRTAStatus, value: false })
                    dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                    dispatch({ type: CheckOut.updateFinalBillStatus, value: true })

                    tempSCData.detailPageName = "accord| info and credit- crd chk fail";
                    tempVzdlSCData.detail = "info and credit- crd chk fail";
                    tempSCData.creditCheck = "Fail";
                    tempVzdlSCData.creditCheck = "Fail";
                    updateSCcustomEvent("checkoutInit", "ddCheckoutEvent", "detailPageName");
                    updateVzdlSCCustomEvent("checkoutInit", "pageViewOmni", "detail");

                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'FINALBILL VEPS REJECTED_CNT:'+ noOfAttempts,PAGEACTIVITY.UA));
                }
            }
            else if (response.meta.code === 500.01) {
                dispatch({ type: CheckOut.updateFinalBillAttempts, value: noOfAttempts + 1 })
                dispatch({ type: FinalBill.finalBillStatus, value: 'fail' })
                dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
                dispatch({ type: CheckOut.updateRTAStatus, value: false })
                dispatch({ type: CheckOut.updateFinalBillStatus, value: true })   
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'FINALBILL VEPS API Error_CNT:'+ noOfAttempts,PAGEACTIVITY.UA));        
            } else{
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'FINALBILL VEPS API Error_CNT:'+ noOfAttempts,PAGEACTIVITY.UA));
            }
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        })
        .catch(error => {
            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
            let errorMsg = `MethodName:doFinalBillPayment,errorMessage:${error.message}`;
            logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs", visitId);
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        });
    }
    else {
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
        dispatch({ type: CheckOut.onUpdateCreditCheckStatus, value: false })
        dispatch({ type: CheckOut.updateRTAStatus, value: false })
        dispatch({ type: FinalBill.finalBillStatus, value: 'fail' })
        dispatch({ type: CheckOut.updateFinalBillStatus, value: true })
    }
}

const doDepositPayment = (visitId,visitorid, dispatch, amount, inputDetail, lqState, noOfAttempts,isTargetOrdering,pfbautopayState,flowType='', mon='') => {
    let paymentCheck = apiUrl().vepsUrl;
    let request = getPaymentRequest(amount, inputDetail, lqState, true,visitId, dispatch);
    if(!request) return;
    dispatch({ 
        type: 'LOADER_ACTIVE', 
        value: { isLoaderActive: true, isLoaderText: "<h2>Please wait.This should only take a moment</h2>", isLoaderImg: "spinner" } 
    });
    api(paymentCheck, 'POST', request).then(response => {
        if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.data) && InHomeUtils.isNotNull(response.data.status)) {
            dispatch({ type: Deposit.onUpdateDeposit, value: response.data });

            if (response.data.status === 'Success') {
                dispatch({ type: Deposit.updateDepositStatus, value: 'success' })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doDepositPayment', "SUBMITORDER-CALLED", PAGEACTIVITY.UA));                
                doSumbitOrder(visitId,visitorid, dispatch,isTargetOrdering,pfbautopayState,flowType,"",mon);
            }
            else if (response.data.status === 'Failed'|| response.data.status === 'Failure') {
                dispatch({ type: Deposit.updateDepositAttempts, value: noOfAttempts + 1 })
                dispatch({ type: Deposit.updateDepositStatus, value: 'fail' })
                dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'DEPOSIT VEPS REJECTED_CNT:'+ noOfAttempts,PAGEACTIVITY.UA));
            }
        }
        else if (InHomeUtils.getIndexOf(response.meta.code, "500")) {
            dispatch({ type: Deposit.updateDepositAttempts, value: noOfAttempts + 1 })
            dispatch({ type: Deposit.updateDepositStatus, value: 'fail' })
            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'DEPOSIT VEPS API Error_CNT:'+ noOfAttempts,PAGEACTIVITY.UA));
        }
        else{
            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.CO,visitId,PAGEACTIVITY.PAGE.ASYNC,'DEPOSIT VEPS API Error_CNT:'+ noOfAttempts,PAGEACTIVITY.UA));
        }        
    })
    .catch(error => {
        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        let errorMsg = `MethodName:doDepositPayment,errorMessage:${error.message}`;
        logKafka("ERROR", "Checkout", errorMsg, getErrorLogUrl, "applogs", visitId);
        dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    });
}
export const doVepsPayment = (visitId, visitorid,dispatch, amount, inputDetail,  lqState, IsDeposit, noOfAttempts,isTargetOrdering,pfbautopayState,flowType='', mon='',isReqdDepositafterFinalBill=false) => {
    if (IsDeposit) {
        doDepositPayment(visitId,visitorid, dispatch, amount, inputDetail, lqState, noOfAttempts,isTargetOrdering,pfbautopayState,flowType,mon)
    }
    else {
        doFinalBillPayment(visitId, dispatch, amount, inputDetail, lqState, noOfAttempts,isReqdDepositafterFinalBill)
    }
};

const getPaymentRequest = (amount, inputDetail, lqState, IsDeposit,visitId, dispatch) => {
    let payeeAddress = ''; //address
    let payeeCity = ''; //city
    let payeeState = ''; //state
    let payeeZipCode = ''; //zip
    let year = '';
    let addressCheck = false;
    let encryption = {
        cardNum: IsDeposit?inputDetail.deposit.cardNumber :inputDetail.finalBill.cardNumber,
        securityCode: IsDeposit?inputDetail.deposit.securityCode:inputDetail.finalBill.securityCode
    }
    let encryptedValue = getPieEncryptionVepsPayment(encryption,visitId);
    var rand = String(Math.floor(100000000000 + Math.random() * new Date().valueOf()));
    var esignrand = rand.length > 12 ? rand.substring(0, 12) : rand;
    if (IsDeposit) {
        inputDetail = inputDetail.deposit;
        addressCheck = inputDetail.depositAddressCheck;
    }
    else {
        inputDetail = inputDetail.finalBill;
        addressCheck = inputDetail.finalBillAddressCheck;
    }
    if (addressCheck) {
        const {isoneLQFlow, selectedUnit, selectedAdr, selectedState} = lqState;
        const unit = selectedUnit && selectedUnit.unit || ""; //(InHomeUtils.isNotNull(lqState.selectedUnit) && InHomeUtils.isNotNull(lqState.selectedUnit.unit)) ? lqState.selectedUnit.unit : "";
        const { state, zip} = selectedState;
        payeeAddress=`${isoneLQFlow ? selectedAdr.dispstr: selectedAdr.street} ${unit}`;   //`${lqState.selectedAdr.street} ${unit}`             
        payeeCity = isoneLQFlow ? selectedState.muni :selectedState.altCity; //lqState.selectedState.altCity;
        payeeState = state; //lqState.selectedState.state;
        payeeZipCode = zip; //lqState.selectedState.zip;
    }
    else {
        const {street,city,stateVal, zip} = inputDetail; 
        payeeAddress = street; //inputDetail.street;
        payeeCity = city; //inputDetail.city;
        payeeState = stateVal; //inputDetail.stateVal;
        payeeZipCode = zip; //inputDetail.zip;
    }
    if (inputDetail.expirationDate.Year != null) {
        year = (inputDetail.expirationDate.Year).substring(2, 4);
    }
    let expDate = (inputDetail.expirationDate.Month + year);
    let request = '';
    if (IsDeposit) {
        request = [{
            client: { name: 'vzcom', id: 'vzcom' },
            data: {
                serviceAction: "deposit",
                transactionSource: "Desktop",
                orderType: "NEW",
                depositamount: amount,
                paymentDetails: [{
                    pmtInd: inputDetail.debitCheck ? "D" : "C",
                    pmtType: inputDetail.cardType,
                    cardNum: encryptedValue ? encryptedValue[0] : '',
                    securityCode: encryptedValue ? encryptedValue[1] : '',
                    profileName: Math.floor(new Date().valueOf() * Math.random()),
                    expirationDt: expDate,
                    payeeName: (inputDetail.firstName + " " + inputDetail.lastName),
                    payeeAddress,//: address,
                    payeeCity,//: city,
                    payeeState,//: state,
                    payeeZipCode//: zip,
                }]
            }
        }]
    }
    else {
        request = [{
            client: { name: 'vzcom', id: 'vzcom' },
            data: {
                serviceAction: "regularpayment",
                transactionSource: "Desktop",
                orderType: "NEW",
                paymentDetails: [{
                    pmtInd: inputDetail.debitCheck ? "D" : "C",
                    pmtType: inputDetail.cardType,
                    cardNum: encryptedValue ? encryptedValue[0] : '',
                    securityCode: encryptedValue ? encryptedValue[1] : '',
                    profileName: "AUTO_17091775978299",
                    amount: amount,
                    expirationDt: expDate,
                    payeeName: (inputDetail.firstName + " " + inputDetail.lastName),
                    payeeAddress,//: address,
                    payeeCity,//: city,
                    payeeState,//: state,
                    payeeZipCode,//: zip,
                    actions: [{ actionCode: "NOTIFY_PPX", eSignConfirmationNum: esignrand, }],
                    bankEncryptionDetails: {
                        keyId: encryptedValue.key_id,
                        phasebit: encryptedValue.phase,
                    }
                }]
            }
        }]
    }
    if(!encryptedValue) {
        if (IsDeposit) {
            dispatch({ type: Deposit.cNumErr, value: true });
        } else {
            dispatch({ type: FinalBill.cNumErr, value: true });
        }
        const cardTypeEle  = document.querySelector('#cardNumber');
        cardTypeEle && cardTypeEle.focus();
        return '';
    }
    return JSON.stringify(request);

}

const getRequestchat = (visitId, visitorId) => {
    let request = { visitId, visitorId, callFrom: "submit" }
    return JSON.stringify(request);
  };

const invokeSendLofNotification =(visitId, dispatch,pfbautopayState)=>{
    let url = apiUrl().sendLofNotification;
    api(url, 'POST', getLofAutoPayRequest(visitId,pfbautopayState))
      .then(response => {
          console.log(response)
      })
      .catch(error => {
          let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
          let errorMsg = `MethodName:invokeSendLofNotification,errorMessage:${error.message}`;
          logKafka("ERROR", "ChatStore submit-error", errorMsg, getErrorLogUrl, "applogs", visitId);
      });
}

const getLofAutoPayRequest = (visitId, pfbautopayState) => {
    let request = {
        data: {
            email: pfbautopayState.lofAutoPayRequest.data.email,
            deliveryType: pfbautopayState.lofAutoPayRequest.data.deliveryType,
            mtn: pfbautopayState.lofAutoPayRequest.data.mtn,
            tosType: pfbautopayState.lofAutoPayRequest.data.tosType,
            pfbIntent: pfbautopayState.lofAutoPayRequest.data.pfbIntent,
            autopayIntent: pfbautopayState.lofAutoPayRequest.data.autopayIntent,
            autopayPromoFlag: pfbautopayState.lofAutoPayRequest.data.autopayPromoFlag,
            productDetails: pfbautopayState.lofAutoPayRequest.data.productDetails,
            orderStatus: "SUBMIT"
        }
    }
    return JSON.stringify(request);
}

const updateOrderStatusInDB = (visitId,orderPlaced) => {
    let url = '/inhome/updateOrderStatus';//apiUrl().orderStatus;
    //  url = 'https://localhost.verizon.com:8080/updateOrderStatus';//apiUrl().orderStatus; //localDev
    api(url, 'POST',JSON.stringify({visitId,orderPlaced}))
    .then(response => {
        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.chatInfo) && InHomeUtils.isNotNull(response.status)) {
          logKafka("SUCESS", "orderStatus submit","orderStatus submit Success", getErrorLogUrl, "applogs", visitId);
        }   
        else{
          logKafka("SUCESS", "orderStatus submit", "orderStatus submit Failure", getErrorLogUrl, "applogs", visitId);
        }
    })
    .catch(error => {
        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        let errorMsg = `MethodName:orderStatus-Update,errorMessage:${error.message}`;
        logKafka("ERROR", "orderStatus submit-error", errorMsg, getErrorLogUrl, "applogs", visitId);
    });

}

export const doSumbitOrderSkip = (visitId, visitorid, dispatch, isTargetOrdering, pfbautopayState, flowType, retunEquip) => {
    updateOrderStatusInDB(visitId, 'Y');
    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "SUBMITORDER-SUCCESS", PAGEACTIVITY.UA));
    dispatch({ type: 'SO_SUBMIT_ORDER_SUCCESS', value: true });

    
        dispatch({ type: 'SET_ENC_ZIP', value: '243234234' })
    
    
        dispatch({ type: 'SET_ENC_MON', value: 'VA40003935505' })
    
    setTimeout(function () {   
        submitOrderClicked(true,dispatch)      
        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "REDIRECTTO-SUBMITORDER", PAGEACTIVITY.UA));
        redirectTo(Pages.SubmitOrder, dispatch);
    }, 3000);
}

export const doSumbitOrder = (visitId,visitorid, dispatch,isTargetOrdering,pfbautopayState, flowType, retunEquip, mon) => {
    if(isTargetOrdering) {
        invokeSendLofNotification(visitId,dispatch,pfbautopayState)
    }
    let url = apiUrl().chatStore;
    api(url, 'POST', getRequestchat(visitId,visitorid))
      .then(response => {
          let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
          if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.getIndexOf(response.meta.code, "200") && InHomeUtils.isNotNull(response.chatInfo) && InHomeUtils.isNotNull(response.status)) {
            logKafka("SUCESS", "ChatStore submit","ChatStore submit Success", getErrorLogUrl, "applogs", visitId);
          }   
          else{
            logKafka("SUCESS", "ChatStore submit", "ChatStore submit Failure", getErrorLogUrl, "applogs", visitId);
          }
      })
      .catch(error => {
          let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
          let errorMsg = `MethodName:doSumbitOrder-Chat Store,errorMessage:${error.message}`;
          logKafka("ERROR", "ChatStore submit-error", errorMsg, getErrorLogUrl, "applogs", visitId);
      });    

    let submitOrder = apiUrl().submitOrder;    
    let request = '';
    let submitOrderMethod = 'GET'
    // if(flowType == 'MV' && retunEquip){
    //     submitOrderMethod = 'POST';
    //     request = JSON.stringify({
    //         'addressIndicator': retunEquip
    //     }) 
    // }

    let smartCartBoolean = false;

    if(InHomeUtils.isNotNull(mon) && InHomeUtils.isNotEmpty(mon)) {  

        let smartCartStatus = getSmartCartStatus(mon, visitId);
                Promise.all([smartCartStatus]).then(function (values) {
                    //Conditions or pre-requisites for already submitted MON
                       if(flowType!=="SUPP" && (InHomeUtils.isNotNull(values) && InHomeUtils.isNotEmpty(values) && InHomeUtils.isNotNull(values[0].meta) && InHomeUtils.isNotEmpty(values[0].meta) && InHomeUtils.getIndexOf(values[0].meta.code, '200') && InHomeUtils.isNotNull(values[0].data))) {
                            if(InHomeUtils.isNotNull(values[0].data.status) && values[0].data.status === 'Success' && InHomeUtils.isNotNull(values[0].data.mon) && InHomeUtils.isNotEmpty(values[0].data.mon) && ((InHomeUtils.isNotNull(values[0].data.orderDetails) && InHomeUtils.isNotNull(values[0].data.orderDetails.order)&& values[0].data.orderDetails.order.length >= 1)||((InHomeUtils.isNotNull(values[0].data.isOrderInSQ) && InHomeUtils.isNotEmpty(values[0].data.isOrderInSQ) && values[0].data.isOrderInSQ.toLowerCase() === "y")||(InHomeUtils.isNotNull(values[0].data.isOrderReceived) && InHomeUtils.isNotEmpty(values[0].data.isOrderReceived) && values[0].data.isOrderReceived.toLowerCase() === "y")))) {
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "getSmartCartStatus MONSubmitted Already :"+ values[0].data.mon, PAGEACTIVITY.UA));
                                smartCartBoolean = true;
                            }
                        }
                    else {
                        logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "getSmartCartStatus Failed", PAGEACTIVITY.UA));
                    }

                    //Routing based on MON submitted or not
                    if(smartCartBoolean) {
                        errorAction("LBO", "Checkout", "MONSubmitted", "", visitId, dispatch, true, "MONSubmitted");
                    }
                    else {
                        dispatch({ 
                            type: 'LOADER_ACTIVE', 
                            value: { isLoaderActive: true, isLoaderText: "Submitting your order", isLoaderImg: "loader" } 
                        });
                        if(window.location.search?.includes('MN=Y') || (window && window.sessionStorage && (window.sessionStorage.getItem('isMidnight') === 'true'))) {
                            submitOrder = submitOrder + '?isMnFlow=Y';
                        }
                        const isRetailFiosReferralCheck = window.sessionStorage.getItem('fiosReferralFlow');
                        const closingAgencyId = window.sessionStorage.getItem('closingAgencyId')
                        const closingSalesCode = window.sessionStorage.getItem('closingSalesCode');
                        if(isRetailFiosReferralCheck){
                            const query = `closingAgencyId=${closingAgencyId}&closingSalesCode=${closingSalesCode}&posLocationCode=`
                            let queryString = submitOrder.includes('?isMnFlow=Y') ? '&' : '?'
                            queryString = queryString + query
                            submitOrder = submitOrder + queryString
                        }
                        logToKibanna(`Inhome:submitOrder:1:${submitOrder}`, "INFO")
                        const message =  sessionStorage.getItem("hostedAttractLoop") ? "fios-common-shell-order" : "fios-bau-order"
                        logToKibanna(`Inhome:submitOrder:type:${message}`, "INFO")
                        api(submitOrder, submitOrderMethod, request).then(response => {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            // if (window.nrTimeState && window.nrTimeState.fromTime) {
                            //     logNRTime(window.nrTimeState, dispatch, 'Summary');
                            // }
                            if(InHomeUtils.isNotNull(response) && InHomeUtils.isNotNull(response.meta) && InHomeUtils.isNotNull(response.meta.code) ){
                                if(response.meta.code === 200.02) {
                                    updateOrderStatusInDB(visitId, 'Y');
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "SUBMITORDER-SUCCESS", PAGEACTIVITY.UA));
                                    dispatch({ type: 'SO_SUBMIT_ORDER_SUCCESS', value: true });            
                                    // redirectTo(Pages.SubmitOrder, dispatch)
                        
                                    // For redirection upon successful LOF registration
                                    if (response.data.encZip) {
                                        dispatch({ type: 'SET_ENC_ZIP', value: response.data.encZip })
                                    }
                                    if (response.data.encMon) {
                                        dispatch({ type: 'SET_ENC_MON', value: response.data.encMon })
                                    }
                                }
                                else if (response.meta.code === 200.3 || response.meta.code === 500.01) {
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "SUBMITORDER-FAILED", PAGEACTIVITY.UA));
                                    dispatch({ type: 'SO_SUBMIT_ORDER_FAILURE', value: false });
                                    dispatch({ type: 'SET_ENC_ZIP', value: null });
                                    dispatch({ type: 'SET_ENC_MON', value: null });
                                }
                                else{
                                    updateOrderStatusInDB(visitId, 'N');
                                    logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "SUBMITORDER-NORESPONSE", 
                                    PAGEACTIVITY.UA));
                                }
                            }
                            else{
                                updateOrderStatusInDB(visitId, 'N');
                                logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', 
                                "SUBMITORDER-NULL RESPONSE" + response, PAGEACTIVITY.UA));
                            }
                        })
                        .catch(error => {
                            dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            let errorMsg = `MethodName:doSumbitOrder,errorMessage:${error.message}`;
                            let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
                            logKafka("ERROR", "Submit", errorMsg, getErrorLogUrl, "applogs", visitId);
                            errorAction("ERROR","Checkout",error.message,"applogs",visitId,dispatch,false,"");
                            // errorAction("LBO","Checkout",error.message,"applogs",visitId,dispatch,true,"SubmitOrderFail");
                            dispatch({ type: 'SET_ENC_ZIP', value: null });
                            dispatch({ type: 'SET_ENC_MON', value: null });       
                        });

                        setTimeout(function () {   
                            submitOrderClicked(true,dispatch)      
                            //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
                            logOtherInfo(detailsInfo(PAGEACTIVITY.PAGE.PO, visitId, 'doSumbitOrder', "REDIRECTTO-SUBMITORDER", PAGEACTIVITY.UA));
                            redirectTo(Pages.SubmitOrder, dispatch);
                        }, 3000);
                    }
                });
                
    }    
};

export const getSmartCartStatus = (mon, visitId) => {
    let smartCartStatusUrl = apiUrl().getSmartCartStatus + "?mon=" + mon;
    try {
        return new Promise((resolve, reject) => {
            api(smartCartStatusUrl, 'GET').then(response => {                
                resolve(response);
            })
        }); 
    }
    catch (ex) {
        catchJSException('Checkout', visitId, 'getSmartCartStatus', ex);
    }       
}

const submitOrderClicked = (status, dispatch) => {
    dispatch({ type: "SUBMIT_ORDER_CLICKED", value: status })
};

export const fNameErr = (status, dispatch) => {
    dispatch({ type: Deposit.fNameErr, value: status })
};
export const lNameErr = (status, dispatch) => {
    dispatch({ type: Deposit.lNameErr, value: status })
};
export const cTypeErr = (status, dispatch) => {
    dispatch({ type: Deposit.cTypeErr, value: status })
};
export const cNumErr = (status, dispatch) => {
    dispatch({ type: Deposit.cNumErr, value: status })
};
export const cVVErr = (status, dispatch) => {
    dispatch({ type: Deposit.cVVErr, value: status })
};
export const expMonthErr = (status, dispatch) => {
    dispatch({ type: Deposit.expMonthErr, value: status })
};
export const expYearErr = (status, dispatch) => {
    dispatch({ type: Deposit.expYearErr, value: status })
};
export const cityErr = (status, dispatch) => {
    dispatch({ type: Deposit.cityErr, value: status })
};

export const streetErr = (status, dispatch) => {
    dispatch({ type: Deposit.streetErr, value: status })
};

export const stateValErr = (status, dispatch) => {
    dispatch({ type: Deposit.stateValErr, value: status })
};
export const zipErr = (status, dispatch) => {
    dispatch({ type: Deposit.zipErr, value: status })
};
